import { DOCUMENT } from '@angular/common';
import { ApplicationRef, ComponentFactoryResolver, Directive, ElementRef, HostListener, Inject, InjectionToken, Injector, Input, OnInit } from '@angular/core';
import { TooltipDirective, TooltipOptions } from 'ng2-tooltip-directive-major-angular-updates';

export const TOOLTIP_OPTIONS = new InjectionToken<TooltipOptions>('tooltip', { providedIn: 'root', factory: () => TooltipDirective.ɵdir })

@Directive({
  selector: '[appSmashTooltip]',
  exportAs: 'appSmashTooltip'
})
export class SmashTooltipDirective extends TooltipDirective implements OnInit {


  @Input() appSmashTooltip: string;
  @HostListener('window:scroll', ['$event']) onScroll($event: any) {
    this.ngOnDestroy()
  }

  constructor(
    @Inject(TOOLTIP_OPTIONS) options: TooltipOptions,
    private _elRef: ElementRef,
    componentFactoryResolver: ComponentFactoryResolver,
    appRef: ApplicationRef,
    injector: Injector,
    @Inject(DOCUMENT) _document: any,

  ) {
    super(
      options,
      _elRef,
      componentFactoryResolver,
      appRef,
      injector
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.tooltipValue = this.appSmashTooltip;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}
